import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Menu, MenuItem } from "@mui/material";
import {
  bindMenu,
  bindTrigger,
  usePopupState,
} from "material-ui-popup-state/hooks";

import { MuiIconButton } from "../../../../../components";
import { COMPONENT_IDS } from "../../../../../helpers/constants/componentIds";
import { useSiteCore } from "../../../../../hooks/useSiteCore";
import { ClientSpecificContent } from "../../../modelsAndSchemas/Models";
import { OptionMenuWrapper } from "./OptionMenu.style";
import { useNavigationSiteCore } from "../../../../../hooks/useNavigationSiteCore";
import PermissionWrapper from "../../../../../components/permissionWrapper/PermissionWrapper";
import { MODULE_PERMISSIONS } from "../../../../../helpers/constants";

export interface OptionMenuProps {
  clientData: ClientSpecificContent;
  onClickOptionEdit: (row: ClientSpecificContent) => void;
  onClickOptionDelete: (row: ClientSpecificContent) => void;
}

export const OptionMenu: React.FC<OptionMenuProps> = ({
  clientData,
  onClickOptionEdit,
  onClickOptionDelete,
}) => {
  const { commonLabels } = useSiteCore();
  const { commonARIALabel } = useNavigationSiteCore();
  const popupState = usePopupState({
    popupId: `${clientData.clientResourceGroupId}`,
    variant: "popover",
  });

  return (
    <OptionMenuWrapper>
      <MuiIconButton
        className="option-menu-icon"
        {...bindTrigger(popupState)}
        id={`${COMPONENT_IDS.COMMON_OPTION_MENU}-${clientData.clientResourceGroupId}`}
        data-testid={`${COMPONENT_IDS.COMMON_OPTION_MENU}-${clientData.clientResourceGroupId}`}
        aria-label={commonARIALabel.moreOptionsForThisTableRow}
      >
        <MoreVertIcon />
      </MuiIconButton>

      <Menu {...bindMenu(popupState)}>
        <PermissionWrapper
          permission={MODULE_PERMISSIONS.EDIT_CLIENT_SPECIFIC_CONTENT}
        >
          <MenuItem
            data-testid={`${COMPONENT_IDS.COMMON_OPTION_MENU_EDIT}-${clientData.clientResourceGroupId}`}
            onClick={() => {
              popupState.close();
              onClickOptionEdit(clientData);
            }}
          >
            {commonLabels.edit}
          </MenuItem>
        </PermissionWrapper>
        <PermissionWrapper
          permission={MODULE_PERMISSIONS.DELETE_CLIENT_SPECIFIC_CONTENT}
        >
          <MenuItem
            data-testid={`${COMPONENT_IDS.COMMON_OPTION_MENU_DELETE}-${clientData.clientResourceGroupId}`}
            onClick={() => {
              popupState.close();
              onClickOptionDelete(clientData);
            }}
          >
            {commonLabels.delete}
          </MenuItem>
        </PermissionWrapper>
      </Menu>
    </OptionMenuWrapper>
  );
};
